import { NotOverridableComponentProps } from '../../../../../model/Component'
import Tab, { TabProps } from '@mui/material/Tab'
import { AppBox } from '../AppBox'

export type AppTabProps = NotOverridableComponentProps<TabProps>

export function AppTab(props: AppTabProps) {
  return (
    <AppBox {...props} component={Tab} />
  )
}
